import React, { FC, ReactElement, KeyboardEvent } from 'react'
import { Row, Col } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faBuilding,
  faEnvelope,
  faPhone,
  faTag,
  IconDefinition,
} from '@fortawesome/free-solid-svg-icons'
import { faLinkedin, faTwitter, faInstagram, faFacebook } from '@fortawesome/free-brands-svg-icons'
import { Link } from 'react-router-dom'
import { Tooltip } from '@material-ui/core'

import newWindow from '../../../../utils/newWindow'

interface Props {
  company?: string
  industry?: string
  email?: string
  name?: string
  phone?: string
  linkedIn?: string
  instagram?: string
  facebook?: string
  twitter?: string
  domain?: string
}

interface Info {
  label: string
  value?: string
  icon: IconDefinition
  link: boolean
  linkValue: string | undefined
  external: boolean
  show: boolean
}

const ContactInfo: FC<Props> = ({
  company,
  industry,
  email,
  phone,
  linkedIn,
  twitter,
  instagram,
  facebook,
}) => {
  const info: Info[] = [
    {
      label: 'Company',
      value: company,
      icon: faBuilding,
      link: false,
      linkValue: '',
      external: false,
      show: true,
    },
    {
      label: 'Industry',
      value: industry,
      icon: faTag,
      link: false,
      linkValue: '',
      external: false,
      show: true,
    },
    {
      label: 'Email',
      value: email,
      icon: faEnvelope,
      link: false,
      linkValue: '',
      external: false,
      show: true,
    },
    {
      label: 'Phone Number',
      value: phone,
      icon: faPhone,
      link: false,
      linkValue: '',
      external: false,
      show: true,
    },
    {
      label: 'LinkedIn',
      value: 'View on LinkedIn',
      icon: faLinkedin,
      link: true,
      linkValue: linkedIn,
      external: true,
      show: true,
    },
    {
      label: 'Twitter',
      value: 'View on Twitter',
      icon: faTwitter,
      link: true,
      linkValue: twitter,
      external: true,
      show: true,
    },
    {
      label: 'Instagram',
      value: 'View on Instagram',
      icon: faInstagram,
      link: true,
      linkValue: instagram,
      external: true,
      show: Boolean(instagram),
    },
    {
      label: 'Facebook',
      value: 'View on Facebook',
      icon: faFacebook,
      link: true,
      linkValue: facebook,
      external: true,
      show: Boolean(facebook),
    },
  ]

  return (
    <div className="contact-info">
      {info.map((i: Info) => {
        if (i.show && i.value && i.linkValue !== undefined) {
          let link: ReactElement | null = null

          if (i.external) {
            link = (
              <p>
                <button
                  className="button-link"
                  onClick={(): void => {
                    newWindow(`${i.linkValue}`, '')
                  }}
                  onKeyDown={(e: KeyboardEvent<HTMLButtonElement>): void => {
                    if (e.keyCode === 13) {
                      newWindow(`${i.linkValue}`, '')
                    }
                  }}
                  type="button"
                >
                  {i.value}
                </button>
              </p>
            )
          } else {
            link = (
              <Link to={i.linkValue ? i.linkValue : '#'}>
                <p>{i.value}</p>
              </Link>
            )
          }

          return (
            <Row key={i.label}>
              <Col xs={1} className="icon">
                <Tooltip title={i.label}>
                  <span>
                    <FontAwesomeIcon icon={i.icon} color="#a7a7a7" size="lg" />
                  </span>
                </Tooltip>
              </Col>
              <Col className="info">{i.link ? link : <p>{i.value}</p>}</Col>
            </Row>
          )
        }

        return null
      })}
    </div>
  )
}

export default ContactInfo
